import { useEffect, useState } from 'react';
import { MOBILE_MEDIA_QUERY } from 'responsive';

const hasMatchMedia = (): boolean => typeof window !== 'undefined' && typeof window.matchMedia === 'function';

const currentMatch = (): boolean => (hasMatchMedia() ? window.matchMedia(MOBILE_MEDIA_QUERY).matches : false);

export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(currentMatch);

  useEffect(() => {
    if (!hasMatchMedia()) return undefined;

    const media = window.matchMedia(MOBILE_MEDIA_QUERY);
    const onChange = (e: MediaQueryListEvent): void => setIsMobile(e.matches);
    setIsMobile(media.matches);

    if (typeof media.addEventListener === 'function') {
      media.addEventListener('change', onChange);
      return (): void => media.removeEventListener('change', onChange);
    }

    // Safari < 14
    media.addListener(onChange);
    return (): void => media.removeListener(onChange);
  }, []);

  return isMobile;
};
